module.exports = __webpack_public_path__ + "60fd58bb937864b01afc8e67282f762e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/4_D#2.mp3
// module id = 101
// module chunks = 0